import { BasicConfig } from '@shared/models/basic-config.interface';

export abstract class LayoutConfig extends BasicConfig {
  privileges: {
    job: {
      view: string;
      create: string;
    };
    candidates: {
      view: string;
      create: string;
    };
    companies: {
      view: string;
      create: string;
    };
    reports: {
      view: string;
    };
    settings: {
      anonymization: string;
      user: string;
      profile: string;
    };
    jobBoards: {
      viewPage: string;
    };
  };
  // below object should match values from _breakpoints.scss
  breakpoints: {
    xs: string;
    sm: string;
    md: string;
    lg: string;
    xl: string;
  };
}

export type LayoutPrivileges = LayoutConfig['privileges'];
